var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTraitIconsConscientiousness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#B1B1B1",
    fillRule: "nonzero",
    opacity: 0.2,
    transform: "translate(1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002554",
    fillRule: "nonzero",
    d: "M31 26.98H1c-.249 0-.45-.201-.45-.45s.201-.45.45-.45h30c.249 0 .45.201.45.45s-.201.45-.45.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002554",
    fillRule: "nonzero",
    d: "M3.763 26.97c-.115 0-.226-.045-.31-.124l-1.769-1.685c-.088-.085-.138-.202-.138-.325s.05-.24.138-.325l1.763-1.692c.083-.08.195-.126.311-.126l13.394-.025c.749.001 1.356.607 1.359 1.356v1.558c0 .75-.606 1.36-1.356 1.362l-13.4.026h.008zm-1.117-2.136l1.3 1.235 13.215-.025c.122 0 .238-.049.324-.135.086-.086.134-.203.134-.325v-1.558c0-.253-.206-.458-.459-.458l-13.214.025-1.3 1.241z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.063 24.026v1.557c0 .241-.095.473-.265.643-.17.171-.4.267-.642.268l-13.395.025L2 24.835l1.762-1.691 13.4-.025c.498.004.9.409.901.907z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425CC7",
    fillRule: "nonzero",
    d: "M15.914 26.531l-.006-2.252h1.333c.342.004.653.196.81.5v.842c-.001.502-.406.909-.908.912l-1.229-.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002554",
    fillRule: "nonzero",
    d: "M3.763 26.97c-.115 0-.226-.045-.31-.124l-1.769-1.685c-.088-.085-.138-.202-.138-.325s.05-.24.138-.325l1.763-1.692c.083-.08.195-.126.311-.126l13.394-.025c.749.001 1.356.607 1.359 1.356v1.558c0 .75-.606 1.36-1.356 1.362l-13.4.026h.008zm-1.117-2.136l1.3 1.235 13.215-.025c.122 0 .238-.049.324-.135.086-.086.134-.203.134-.325v-1.558c0-.253-.206-.458-.459-.458l-13.214.025-1.3 1.241z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002554",
    fillRule: "nonzero",
    d: "M15.827 26.946c-.248 0-.45-.2-.45-.449l-.007-3.375c0-.248.2-.45.449-.451.248 0 .45.2.45.449l.007 3.375c0 .248-.2.45-.449.451zM14.009 26.95c-.248 0-.45-.2-.45-.449l-.007-3.375c0-.248.202-.45.45-.451.248 0 .45.2.45.449l.008 3.376c0 .248-.202.45-.45.451l-.001-.001zM4.873 26.968c-.248 0-.45-.2-.45-.449l-.007-3.376c0-.248.2-.45.449-.452.248 0 .45.202.45.45l.007 3.376c0 .248-.2.45-.449.451zM19.2 22.717c-.12 0-.234-.048-.318-.132l-3.7-3.695h-7.03c-1.001-.002-1.812-.813-1.813-1.814V4.833c.001-1 .812-1.812 1.813-1.813h16.853c1 .001 1.812.812 1.813 1.813V7.4c0 .249-.201.45-.45.45s-.45-.201-.45-.45V4.833c0-.504-.409-.912-.913-.913H8.152c-.504 0-.913.409-.913.913v12.243c0 .504.409.913.913.913h7.22c.12 0 .234.048.318.132l3.059 3.06v-2.742c0-.248.202-.45.45-.45h1.987c.237.016.421.213.421.45 0 .237-.184.434-.421.45h-1.537v3.377c0 .182-.11.346-.278.416-.054.022-.112.034-.171.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M29.846 19.6c-.005-1.919-1.56-3.473-3.478-3.478-1.918.006-3.472 1.56-3.477 3.478v6.935h6.955V19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425CC7",
    fillRule: "nonzero",
    d: "M29.846 18.911c-.004-1.54-1.252-2.79-2.793-2.793-1.541.003-2.79 1.252-2.794 2.793v7.62h5.587v-7.62z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.368,
    cy: 11.688,
    r: 2.555
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002554",
    fillRule: "nonzero",
    d: "M26.368 14.693c-1.216 0-2.312-.733-2.776-1.857-.465-1.123-.206-2.416.654-3.275s2.154-1.114 3.277-.648c1.122.467 1.853 1.564 1.851 2.78-.004 1.657-1.349 2.999-3.006 3zm0-5.11c-1.158.003-2.096.943-2.095 2.102 0 1.158.94 2.097 2.098 2.098 1.159 0 2.1-.937 2.102-2.095-.002-1.162-.943-2.103-2.105-2.105zM29.845 26.98H22.89c-.248 0-.45-.202-.45-.45V19.6c0-2.17 1.759-3.928 3.928-3.928 2.17 0 3.928 1.759 3.928 3.928v6.93c-.001.248-.203.45-.451.45zm-6.5-.9H29.4V19.6c0-1.081-.577-2.08-1.513-2.621-.937-.541-2.09-.541-3.027 0-.937.54-1.514 1.54-1.514 2.621l-.001 6.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425CC7",
    fillRule: "nonzero",
    d: "M10.415 15.879c-.12 0-.234-.047-.319-.132l-.84-.841c-.165-.177-.16-.454.011-.625.171-.171.448-.176.625-.011l.523.522 1.917-1.917c.176-.176.46-.175.636 0 .176.176.176.461 0 .637l-2.235 2.235c-.084.085-.199.132-.318.132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002554",
    fillRule: "nonzero",
    d: "M21.249 15.179h-6.312c-.237-.016-.421-.213-.421-.45 0-.237.184-.434.421-.45h6.312c.237.016.421.213.421.45 0 .237-.184.434-.421.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425CC7",
    fillRule: "nonzero",
    d: "M10.415 12.129c-.118 0-.23-.047-.315-.129l-.84-.841c-.165-.177-.16-.454.011-.625.171-.171.448-.176.625-.011l.523.522 1.917-1.917c.176-.176.46-.175.636 0 .176.176.176.461 0 .637L10.733 12c-.085.084-.2.13-.318.129z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002554",
    fillRule: "nonzero",
    d: "M20.392 11.429h-5.455c-.237-.016-.421-.213-.421-.45 0-.237.184-.434.421-.45h5.455c.237.016.421.213.421.45 0 .237-.184.434-.421.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425CC7",
    fillRule: "nonzero",
    d: "M10.415 8.379c-.12 0-.234-.048-.319-.132l-.84-.847c-.165-.177-.16-.454.011-.625.171-.171.448-.176.625-.011l.523.523 1.917-1.917c.176-.176.46-.175.636 0 .176.176.176.461 0 .637l-2.235 2.24c-.084.084-.199.132-.318.132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002554",
    fillRule: "nonzero",
    d: "M22.106 7.679h-7.169c-.237-.016-.421-.213-.421-.45 0-.237.184-.434.421-.45h7.169c.237.016.421.213.421.45 0 .237-.184.434-.421.45z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraitIconsConscientiousness);
export default __webpack_public_path__ + "static/media/trait-icons-conscientiousness.1a677dd89ecac382a1441a5def6598db.svg";
export { ForwardRef as ReactComponent };